// extracted by mini-css-extract-plugin
export default {"container":"PopNotification_container__A7aUc","notification":"PopNotification_notification__pLxN7","toast-in-right":"PopNotification_toast-in-right__S3k4N"};